import { i18n } from '@zet/localization'

import { FormBuilder } from '../../modules/formBuilder'
import { LoadingScreen } from '../../modules/loadingScreen'
import LoanApplicationDetails from '../../modules/loanApplicationDetails'
import Otp from '../../modules/otp'
import Review from '../../modules/review'
import { StatusScreen } from '../../modules/statusScreen'
import { loanType } from '../../types'
import { ApplicationMap } from '../applicationStatusMap'

export const hlStateMap = {
  HL_START: {
    Component: LoadingScreen,
  },
  HL_CUST_FLOW: {
    Component: LoanApplicationDetails,
    props: {
      type: loanType.homeLoan,
      title: i18n.t('loanApplications.stepsToFillLoanApplication.title'),
      steps: [
        i18n.t('loanApplications.stepsToFillLoanApplication.step2'),
        i18n.t('loanApplications.stepsToFillLoanApplication.step7'),
        i18n.t('loanApplications.stepsToFillLoanApplication.step4'),
      ],
      privacyNote: {
        title: i18n.t('loanApplications.loanApplicationPrivacyNote.title'),
        pcNotes: [
          {
            prefix: '\u2022',
            text: i18n.t('loanApplications.loanApplicationPrivacyNote.note2'),
          },
          {
            prefix: '\u2022',
            text: i18n.t('loanApplications.loanApplicationPrivacyNote.note3'),
            link: i18n.t(
              'loanApplications.loanApplicationPrivacyNote.privacyPolicy'
            ),
          },
        ],
      },
    },
  },
  HL_PERSONAL_DETAILS: {
    Component: FormBuilder,
  },
  HL_PROPERTY_DETAILS: {
    Component: FormBuilder,
  },
  HL_EMP_DETAILS: {
    Component: FormBuilder,
  },
  HL_REVIEW: {
    Component: Review,
    props: {
      consents: [
        '<div><p>I hereby confirm that all the information I am submitting has been provided by the customer with their full consent. I have not altered or modified any of the details in any way.</div>',
        '<div><p>I hereby confirm that the information submitted is correct to the best of my knowledge. I authorise Vistas Technolabs Pvt Ltd and their partners to contact me for processing of my loan.</div>', // for customer
      ],
    },
  },
  HL_OTP_BLOCKED: {
    Component: StatusScreen,
    props: {
      status: {
        title: 'Oh No!\nYou have exceeded the maximum \nno. of OTP attempts',
        image: 'ERROR_RETRY',
      },
      showTimeLeft: true,
    },
  },
  HL_OTP_GENERATED: {
    Component: Otp,
  },
  HL_OTP_SUBMISSION: {
    Component: Otp,
  },
  HL_SERVER_ERROR: {
    Component: StatusScreen,
    props: {
      status: {
        title: 'Oops! \n Something Went Wrong',
        subTitle:
          "We're currently unable to process this request due to a technical issue. Please try again.",
        image: 'SERVER_ERROR',
      },
    },
  },
  HL_HANDLE_ERROR: {
    Component: StatusScreen,
    props: {
      status: {
        title: 'Oops! \n Something Went Wrong',
        subTitle:
          "We're currently unable to process this request due to a technical issue. Please try again.",
        image: 'SERVER_ERROR',
      },
    },
  },
  HL_APPLICATION_UNDER_REVIEW: {
    Component: StatusScreen,
    props: {
      status: {
        title: 'Details Submitted Successfully \nApplication Under Review!',
        subTitle:
          'Customer details submitted successfully! A ZET Loan expert will contact the customer soon to continue the process',
        image: 'SUBMITTEDFILLED',
        applicationType: 'pl',
        status: ApplicationMap['under_review'],
      },
      secondaryButton: {
        action: 'REDIRECT_LEAD_DETAILS',
        title: i18n.t('loanApplications.loanDetailsSubmitted.viewLeadDetails'),
      },
    },
  },
}
